// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import styles from './styles.css.js';

const sidePositionIcon = (
  <svg
    className={styles['preference-icon--svg']}
    focusable="false"
    viewBox="0 0 239 134"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect
          className={styles['preference-icon--layout-border']}
          strokeWidth="2"
          x="1"
          y="1"
          width="223"
          height="125"
          rx="2"
        ></rect>
        <rect
          className={styles['preference-icon--layout-background']}
          x="11.25"
          y="0"
          width="203.4375"
          height="125"
        ></rect>
        <path
          className={styles['preference-icon--layout-header']}
          d="M2,0 L223,0 C224.104569,-2.02906125e-16 225,0.8954305 225,2 L225,10 L225,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
        ></path>
      </g>
      <g transform="translate(20.000000, 22.000000)">
        <rect
          className={styles['preference-icon--border']}
          strokeWidth="2"
          x="1"
          y="1"
          width="182"
          height="110"
          rx="2"
        ></rect>
        <rect className={styles['preference-icon--primary-button']} x="152" y="6" width="26" height="10"></rect>
        <rect className={styles['preference-icon--disabled-element']} x="122" y="6" width="26" height="10"></rect>
        <rect className={styles['preference-icon--disabled-element']} x="92" y="6" width="26" height="10"></rect>
        <rect className={styles['preference-icon--disabled-element']} x="122" y="29" width="55" height="3"></rect>
        <rect className={styles['preference-icon--disabled-element']} x="92" y="29" width="26" height="3"></rect>
        <polygon className={styles['preference-icon--focus-text']} points="19 29 49 29 49 32 19 32"></polygon>
        <polygon className={styles['preference-icon--focus-text']} points="10 10 40 10 40 13 10 13"></polygon>
        <polygon className={styles['preference-icon--disabled-element']} points="10 29 13 29 13 32 10 32"></polygon>
        <line
          className={styles['preference-icon--separator']}
          x1="3"
          y1="22.7619048"
          x2="181"
          y2="22.7619048"
          strokeWidth="2"
          strokeLinecap="square"
        ></line>
        <g transform="translate(3.000000, 37.285714)">
          <rect className={styles['preference-icon--disabled-element']} x="119" y="6" width="55" height="3"></rect>
          <rect className={styles['preference-icon--disabled-element']} x="89" y="6" width="26" height="3"></rect>
          <polygon className={styles['preference-icon--focus-text']} points="16 6 46 6 46 9 16 9"></polygon>
          <polygon className={styles['preference-icon--disabled-element']} points="7 6 10 6 10 9 7 9"></polygon>
          <line
            className={styles['preference-icon--separator']}
            x1="0"
            y1="0.666666667"
            x2="178"
            y2="0.666666667"
            strokeLinecap="square"
          ></line>
        </g>
        <g transform="translate(3.000000, 51.714286)">
          <rect className={styles['preference-icon--disabled-element']} x="119" y="6" width="55" height="3"></rect>
          <rect className={styles['preference-icon--disabled-element']} x="89" y="6" width="26" height="3"></rect>
          <polygon className={styles['preference-icon--focus-text']} points="16 6 46 6 46 9 16 9"></polygon>
          <polygon className={styles['preference-icon--disabled-element']} points="7 6 10 6 10 9 7 9"></polygon>
          <line
            className={styles['preference-icon--separator']}
            x1="0"
            y1="0.666666667"
            x2="178"
            y2="0.666666667"
            strokeLinecap="square"
          ></line>
        </g>
        <g transform="translate(3.000000, 80.571429)">
          <rect className={styles['preference-icon--disabled-element']} x="119" y="6" width="55" height="3"></rect>
          <rect className={styles['preference-icon--disabled-element']} x="89" y="6" width="26" height="3"></rect>
          <polygon className={styles['preference-icon--focus-text']} points="16 6 46 6 46 9 16 9"></polygon>
          <polygon className={styles['preference-icon--disabled-element']} points="7 6 10 6 10 9 7 9"></polygon>
          <line
            className={styles['preference-icon--separator']}
            x1="0"
            y1="0.666666667"
            x2="178"
            y2="0.666666667"
            strokeLinecap="square"
          ></line>
        </g>
        <g transform="translate(3.000000, 66.142857)">
          <rect className={styles['preference-icon--disabled-element']} x="119" y="6" width="55" height="3"></rect>
          <rect className={styles['preference-icon--disabled-element']} x="89" y="6" width="26" height="3"></rect>
          <polygon className={styles['preference-icon--focus-text']} points="16 6 46 6 46 9 16 9"></polygon>
          <polygon className={styles['preference-icon--disabled-element']} points="7 6 10 6 10 9 7 9"></polygon>
          <line
            className={styles['preference-icon--separator']}
            x1="0"
            y1="0.666666667"
            x2="178"
            y2="0.666666667"
            strokeLinecap="square"
          ></line>
        </g>
        <g transform="translate(3.000000, 95.000000)">
          <rect className={styles['preference-icon--disabled-element']} x="119" y="6" width="55" height="3"></rect>
          <rect className={styles['preference-icon--disabled-element']} x="89" y="6" width="26" height="3"></rect>
          <polygon className={styles['preference-icon--focus-text']} points="16 6 46 6 46 9 16 9"></polygon>
          <polygon className={styles['preference-icon--disabled-element']} points="7 6 10 6 10 9 7 9"></polygon>
          <line
            className={styles['preference-icon--separator']}
            x1="0"
            y1="0.666666667"
            x2="178"
            y2="0.666666667"
            strokeLinecap="square"
          ></line>
        </g>
      </g>
      <g transform="translate(182.000000, 28.000000)">
        <g>
          <rect
            className={styles['preference-icon--border']}
            strokeWidth="2"
            x="1"
            y="1"
            width="55"
            height="97"
            rx="2"
          ></rect>
          <rect
            className={styles['preference-icon--secondary']}
            x="39.5474354"
            y="5.86666667"
            width="14"
            height="6.41666667"
          ></rect>
          <polygon
            className={styles['preference-icon--focus-text']}
            points="3.62672811 7.88333333 24.6267281 7.88333333 24.6267281 10.6333333 3.62672811 10.6333333"
          ></polygon>
        </g>
        <g transform="translate(4.000000, 22.000000)" className={styles['preference-icon--secondary']}>
          <polygon points="0 0 23 0 23 2 0 2"></polygon>
          <polygon points="26 0 49 0 49 2 26 2"></polygon>
        </g>
        <g transform="translate(4.000000, 32.000000)" className={styles['preference-icon--secondary']}>
          <polygon points="0 0 23 0 23 2 0 2"></polygon>
          <polygon points="26 0 49 0 49 2 26 2"></polygon>
        </g>
        <g transform="translate(4.000000, 43.000000)" className={styles['preference-icon--secondary']}>
          <polygon points="0 0 23 0 23 2 0 2"></polygon>
          <polygon points="26 0 49 0 49 2 26 2"></polygon>
        </g>
        <g transform="translate(4.000000, 51.000000)" className={styles['preference-icon--secondary']}>
          <polygon points="0 0 23 0 23 2 0 2"></polygon>
          <polygon points="26 0 49 0 49 2 26 2"></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export default sidePositionIcon;



// WEBPACK FOOTER //
// /Volumes/src/split-panel/icons/side-position.tsx